import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CardListFilterState, FilterTypes } from '../types';
import PriceFilter from './priceFilter';
import CalendarFilter from './calendarFilter';
import MultiChoiceFilter from './multiChoiceFilter';
import { toggleFilterVisibilityOnSmall, clear } from '../filterListSlice';
import { isMultiFilter, isRangeFilter } from '../utils';
import Modal from 'react-modal';
import { ScreenSize } from '@common/types';
import useScreenSize from '@common/hooks/useScreenSize';

const FiltersContainer = () => {
  const screenSize = useScreenSize();

  const dispatch = useDispatch();
  let filters = useSelector((state: CardListFilterState) => state.filters);
  let isVisibleOnSmall = useSelector(
    (state: CardListFilterState) => state.isFilterVisibleOnSmall,
  );

  const translations = useSelector(
    (state: CardListFilterState) => state.translations,
  );
  const sectionId = useSelector(
    (state: CardListFilterState) => state.sectionId,
  );
  const isFilterDataValid = filters && filters.length > 0;

  useEffect(() => {
    Modal.setAppElement('body');
    const toggleElement = document.querySelector('.js-filter-toggle');
    if (toggleElement) {
      toggleElement.addEventListener('click', () => {
        dispatch(toggleFilterVisibilityOnSmall());
      });
    }
  }, []);

  const handleApplyButton = () => {
    dispatch(toggleFilterVisibilityOnSmall());
    if (
      window.globalUtils &&
      window.globalUtils.scrollToSection &&
      screenSize <= ScreenSize.Lg
    ) {
      window.globalUtils.scrollToSection(`#${sectionId}`);
    }
  };

  if (isFilterDataValid) {
    const clearButton = (
      <div
        className='text-center font-weight-bold tour__filter__clear tour__filter__button'
        onClick={() => dispatch(clear())}
      >
        <div>{translations.clear}</div>
      </div>
    );

    const closeButton =
      screenSize > ScreenSize.Lg ? null : (
        <div
          className='tour__filter__header tour__filter__close'
          onClick={() => dispatch(toggleFilterVisibilityOnSmall())}
        >
          <i className='fas fa-times'></i>&nbsp;
          {translations.close}
        </div>
      );

    const content = (
      <div className='col-12 col-xl-3 tour__filter__container'>
        {closeButton}
        <div className='tour__filter__collection'>
          {filters.map((filter, index) => {
            switch (filter.type) {
              case FilterTypes.Price:
                return isRangeFilter(filter) ? (
                  <PriceFilter
                    category={filter}
                    index={index}
                    key={`fc_${filter.id}`}
                  />
                ) : null;
              case FilterTypes.Month:
                return isMultiFilter(filter) ? (
                  <CalendarFilter
                    category={filter}
                    index={index}
                    key={`fc_${filter.id}`}
                  />
                ) : null;
              case FilterTypes.Checkbox:
                return isMultiFilter(filter) ? (
                  <MultiChoiceFilter
                    category={filter}
                    index={index}
                    key={`fc_${filter.id}`}
                  />
                ) : null;
            }
          })}
        </div>
        {screenSize > ScreenSize.Lg ? (
          clearButton
        ) : (
          <div className='tour__filter__modal-buttons'>
            <div
              onClick={() => handleApplyButton()}
              className='text-center font-weight-bold tour__filter__apply tour__filter__button'
            >
              <div>{translations.apply}</div>
            </div>
            {clearButton}
          </div>
        )}
      </div>
    );

    if (screenSize > ScreenSize.Lg) {
      return content;
    }

    const modalStyle = {
      overlay: {
        zIndex: 1050,
      },
    };
    return (
      <Modal
        isOpen={isVisibleOnSmall}
        style={modalStyle}
        className='tour__filter__modal'
      >
        {content}
      </Modal>
    );
  } else {
    return null;
  }
};

export default FiltersContainer;
